import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { Alert, AlertType } from '@myob/myob-widgets';
import { ENotificationStatus } from 'modules/ProductManagement/type';
import { INotification, TProduct } from 'modules/ProductManagement/reducers/type';
import { getFirstElementInProductList } from '../../reducers/accessors';

const AlertBanner: React.FC = () => {
    const { notifications } = useSelector<RootState, TProduct>(getFirstElementInProductList);

    const notificationsWithoutActions = notifications?.filter(
        (notification: INotification) => notification.type !== ENotificationStatus.ACTION,
    );

    if (!notificationsWithoutActions || notificationsWithoutActions?.length === 0) return null;

    return (
        <>
            {notificationsWithoutActions.map((notification, index) => {
                return (
                    <Alert key={index} type={notification.type as AlertType}>
                        {notification.message}
                    </Alert>
                );
            })}
        </>
    );
};

export default AlertBanner;
